import axios, { type AxiosResponse } from 'axios'

import { API_ENDPOINTS } from '@/constants/apiEndpoints'
import type { CooperantOrderLookup } from '@/types/domain/orders/cooperant'

class CooperantOrdersLookupQueries {
    fetchByOrderNumbers(orderNumbers: string[]): Promise<AxiosResponse<CooperantOrderLookup[]>> {
        const encodedOrderNumbers = encodeURIComponent(orderNumbers.join(','))

        return axios.get<CooperantOrderLookup[]>(
            `${API_ENDPOINTS.COOPERANT_ORDERS.BY_ORDER_NUMBERS}?orderNumbers=${encodedOrderNumbers}`
        )
    }
}

export default new CooperantOrdersLookupQueries()
